import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import FileInput from '../../uikit/fileInput/FileInput';
import { JsonifiedFile } from '../../utility/functions';
import _ from 'lodash';

interface IUploadModalProps {
  isOpen: boolean;
  onUpload: (files: JsonifiedFile[]) => void;
  onCancel: () => void;
}

export default function UploadModal({ isOpen, onCancel, onUpload }: IUploadModalProps) {
  const [files, setFiles] = useState<JsonifiedFile[]>([]);

  useEffect(() => {
    if (isOpen) {
      setFiles([]);
    }
  }, [isOpen]);

  const handleFileUpload = (uploadedFiles: JsonifiedFile[]) => {
    setFiles(uploadedFiles);
  };

  const handleUpload = () => {
    onUpload(files);
    onCancel();
  };

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth>
      <DialogTitle>Upload New Files</DialogTitle>
      <DialogContent>
        <FileInput files={files} setFiles={setFiles} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleUpload} disabled={_.isEmpty(files)}>
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
